import React, { useEffect } from "react";
import Accordion from "react-bootstrap/Accordion";
import { DATA_TYPE, DATA_TYPE_HANDLER, INTEL_CLOUDINARY_BASE_URL } from "../../utils/enum";
import classes from "./api-integration.module.scss";

const ResponseBody = ({ apiData }) => {
  return (
    <div className={classes.res_body_container}>
      {apiData?.new_response_body?.map((item) => (
        <CustomAccordion item={item} />
      ))}
    </div>
  );
};

const CustomAccordion = ({ item }) => {
  return (
    <Accordion defaultActiveKey="0">
      <Accordion.Item eventKey="0" className={classes.req_body_api_accordion}>
        <Accordion.Header>
          {(item.type === DATA_TYPE.array || item.type === DATA_TYPE.object) && item.children ? (
            <span className="me-2">
              <img src={`${INTEL_CLOUDINARY_BASE_URL}/image/upload/v1690459887/intel/icons/down_arrow_w2f5f8.svg`} />
            </span>
          ) : (
            <></>
          )}
          <span className={classes[DATA_TYPE_HANDLER[item.type.toString()]?.class]}>{DATA_TYPE_HANDLER[item.type.toString()].label}</span>
          <span>{item.key ? item.key : item.type}</span>
        </Accordion.Header>
        <Accordion.Body className="p-0">
          <div className={`${classes.req_api_container} ps-4`}>{item?.children?.length ? item.children.map((val) => <CustomAccordion item={val} />) : ""}</div>
        </Accordion.Body>
      </Accordion.Item>
    </Accordion>
  );
};

export default ResponseBody;
